import { DpDrawer } from '@/components/blocks/DpDrawer';
import { DpModal } from '@/components/blocks/DpModal';
import { useMobileHeaderQuery } from '@/components/content/Header';

export const AdaptiveDialog: React.FC<
	React.PropsWithChildren<{
		onClose: () => void;
		title?: string;
		open?: boolean;
	}>
> = ({ children, onClose, title = '', open = true }) => {
	const isMobile = useMobileHeaderQuery();

	if (isMobile) {
		return (
			<DpDrawer title={title} open={open} onClose={onClose}>
				{children}
			</DpDrawer>
		);
	}

	return (
		<DpModal title={title} open={open} onClose={onClose}>
			{children}
		</DpModal>
	);
};
